export default {
  noDumps: 'Aucun dump disponible. Générer un nouveau dump ?',
  metricsDisabled: 'Les métriques des moteurs sont désactivées',
  generateDump: 'Générer un nouveau dump',
  downloadDump: 'Télécharger le dump',
  enabled: 'Mesures techniques activées',
};
